export default __webpack_public_path__ + "media/color/nlg-8c23b541.svg";